
import React from 'react';
import thunk from 'redux-thunk';
import {
  createStore,
  applyMiddleware,
} from 'redux';
import {
  Provider,
} from 'react-redux';
import {
  Router,
  Route,
  IndexRoute,
  IndexRedirect,
  browserHistory,
} from 'react-router';
import authMiddleware from './middlewares/authMiddleware.js';
import reducer from './reducers/index.js';
import {
  syncHistoryWithStore,
  routerMiddleware,
} from 'react-router-redux';

export const store = createStore(reducer, {}, applyMiddleware(
  thunk,
  routerMiddleware(browserHistory),
  authMiddleware,
));

// Pages
import MainBoard from './components/MainBoard.js';
import IndexPage from './components/IndexPage.js';
import SpecificationList from './containers/Specifications/SpecificationList.js';
import SpecificationViewer from './containers/Specifications/SpecificationViewer.js';
import Comparisons from './components/Comparisons/Comparisons.js';
import Questions from './components/Questions/Questions.js';
import Ears from './components/Ears/Ears.js';
import EarHair from './components/EarHair/EarHair.js';
import DetectionBoard from './components/Detections/DetectionBoard.js';
import DetectionIntro from './components/Detections/DetectionIntro.js';
import DetectionIntroViewer from './components/Detections/DetectionIntroViewer.js';
import DetectionTestViewer from './components/Detections/DetectionTestViewer.js';
import DetectionTestResult from './containers/Detections/DetectionTestResult.js';
import SelectionTypeList from './containers/Selections/SelectionTypeList.js';
import SelectionCharacterList from './containers/Selections/SelectionCharacterList.js';
import SelectionColorList from './containers/Selections/SelectionColorList.js';
import SimulatorDefault from './containers/Simulators/SimulatorDefault.js';
import SimulatorLeftEar from './containers/Simulators/SimulatorLeftEar.js';
import SimulatorRightEar from './containers/Simulators/SimulatorRightEar.js';
import SimulatorResult from './containers/Simulators/SimulatorResult.js';
import ReservationBoard from './components/Reservations/ReservationBoard.js';
import Reservations from './containers/Reservations/Reservations.js';

const history = syncHistoryWithStore(browserHistory, store);

export default (
  <Provider store={store}>
    <Router history={history}>
      <Route path="/" component={MainBoard}>
        <Route path="simulators" title="聽力模擬" group="simulators">
          <IndexRoute component={SimulatorDefault} />
          <Route path="left-ear" component={SimulatorLeftEar} />
          <Route path="right-ear" component={SimulatorRightEar} />
          <Route path="result" component={SimulatorResult} />
        </Route>
        <Route path="specifications" title="功能比較" group="specifications">
          <Route path=":specKey" component={SpecificationViewer} />
          <IndexRoute component={SpecificationList} />
        </Route>
        <Route path="comparisons" title="單雙耳比較" group="comparisons" component={Comparisons} />
        <Route path="questions" title="為何需配戴助聽器" group="questions" component={Questions} />
        <Route path="ears" title="耳朵模擬圖" group="ears" component={Ears} />
        <Route path="earHair" title="耳毛細胞比較圖" group="earHair" component={EarHair} />
        <Route path="selections" title="選配室" group="selections">
          <Route path="characters" component={SelectionCharacterList} />
          <Route path="colors" component={SelectionColorList} />
          <IndexRoute component={SelectionTypeList} />
        </Route>
        <IndexRedirect to="/entry" />
      </Route>
      <Route path="/detections" component={DetectionBoard} title="自我聽篩" group="detections">
        <IndexRoute component={DetectionIntro} />
        <Route path="intro/step:key" component={DetectionIntroViewer} />
        <Route path="test/:type/step:key" component={DetectionTestViewer} />
        <Route path="test/result" component={DetectionTestResult} />
      </Route>
      <Route path="/reservations" component={ReservationBoard} title="預約來店" group="reservations">
        <IndexRoute component={Reservations} />
      </Route>
      <Route path="/entry" component={IndexPage} />
    </Router>
  </Provider>
);



// WEBPACK FOOTER //
// ./app.js